module.exports = require("@olympeio-extensions/crypto");